<template>
    <div>
        <base-header type="gradient-dbm" class="pb-6 pb-8 pt-5 pt-md-8"/>

        <div class="container-fluid mt--7">
            <div class="row">
                <div class="col" v-bind:style="{cursor:pointer2}">
                    <consultants-table
                            title="Consultores DBMenos"
                            :data="tableData"
                            v-on:onNewItem="onNewItem"
                            v-on:rowSelected="rowSelected"
                            v-on:insertRow="insertRow"/>
                </div>
            </div>
        </div>

        <modal :show.sync="modal">
            <template slot="header">
                <h1 class="modal-title" id="modal">Editando</h1>
            </template>
            <div class="row">
                <div class="col-md-8">
                    <base-input alternative=""
                                label="Usuario"
                                input-classes="form-control-alternative"
                                v-model="selectedConsultant.username"/>
                </div>
                <div class="col-md-4 form-group">
                    <label class="form-control-label" for="enableControl">Habilitado</label>
                    <select v-model="selectedConsultant.enabled" class="form-control" id="enableControl">
                        <option value="1">Habilitado</option>
                        <option value="0">Deshabilitado</option>
                    </select>
                </div>
            </div>
            <div class="row">
                <div class="col">
                    <base-input alternative=""
                                label="Nombre"
                                input-classes="form-control-alternative"
                                v-model="selectedConsultant.name"/>
                </div>
                <div class="col">
                    <base-input alternative=""
                                label="Primer apellido"
                                input-classes="form-control-alternative"
                                v-model="selectedConsultant.lastname_1"/>
                </div>
                <div class="col">
                    <base-input alternative=""
                                label="Segundo apellido"
                                input-classes="form-control-alternative"
                                v-model="selectedConsultant.lastname_2"/>
                </div>
            </div>
            <div class="row">
                <div class="col">
                    <base-input alternative=""
                                label="Teléfono"
                                input-classes="form-control-alternative"
                                v-model="selectedConsultant.phone"/>
                </div>
                <div class="col">
                    <label class="form-control-label" for="roleControl">Rol</label>
                    <select v-model="selectedConsultant.role" class="form-control" id="roleControl">
                        <option v-for="(r, i) in roles" :key="i" v-bind:value="r">{{getRoleName(r)}}</option>
                    </select>
                </div>
                <div class="col">
                    <base-input alternative=""
                                label="Contraseña"
                                input-classes="form-control-alternative"
                                v-model="selectedConsultant.password"/>
                </div>
            </div>
            <template slot="footer">
                <base-button v-on:click="setConsultant()">Guardar</base-button>
            </template>
        </modal>

    </div>
</template>
<script>
  import ConsultantsTable from './Tables/ConsultantsTable'
  export default {
      name: 'tables',
      components: {
          ConsultantsTable
      },
      mounted() {
          this.getConsultants()
//          console.log("Consultants")
      },
      computed: {
          user() { return this.$getLS(this.$v.STORE_KEYS.USER) },
      },
      data() {
          return {
              modal: false,
              selectedConsultant: {},
              tableData: [],
              pointer: 'pointer',
              pointer2: 'default',
              roles: ['admin', 'seller', 'service', 'finamigo', 'manager_service', 'manager_seller']
          };
      },
      methods: {
          onNewItem() {
              this.selectedConsultant = {}
              this.modal = true
          },
          rowSelected(row) {
              this.selectedConsultant = JSON.parse(JSON.stringify(row))
              this.modal = true
          },
          insertRow() {
              this.selectedConsultant = {}
              this.modal = true
          },
          getRoleName(role) {
              switch (role) {
                  case 'admin': return "Administrador"
                  case 'seller': return "Vendedor"
                  case 'service': return "Servicio"
                  case 'finamigo': return "Finamigo"
                  case 'manager_service': return "Gerente de servicio"
                  case 'manager_seller': return "Gerente de ventas"
              }
          },
          async setConsultant() {
              let url = this.$v.SERVER + this.$v.ADMIN_OPS.SET_CONSULTANT
              this.$showLoader(true)
              let response = await this.$axios.post(url, this.selectedConsultant)
              let data = response.data
              if (data[this.$v.API_SUCCESS]) {
                  setTimeout( async() => {
                      this.modal = false
                      await this.getConsultants()
                      this.$forceUpdate()
                  }, 500)
              } else {
                  this.$showLoader(false)
                  this.$validateSession(data)
              }
          },
          async getConsultants() {
              let url = this.$v.SERVER + this.$v.SELLER_OPS.GET_CONSULTANTS
              this.$showLoader(true)
              let response = await this.$axios.get(url)
              this.$showLoader(false)
              let data = response.data
              if (data[this.$v.API_SUCCESS]) {
                  this.tableData = data[this.$v.API_ROWS]
              } else { this.$validateSession(data) }
          },
      }
  };
</script>
<style></style>